<div class="method-switcher" tappable (click)="goToMethodSelection()">
  <i class="fas fa-exchange-alt"></i> {{ 'CHANGE' | translate }}
</div>
